import {Component, Input, OnInit} from '@angular/core';
import {OfferRecommendation} from '../../../../../core/services/impl/offer-recommendations-api.service';
import {TranslationContainerComponent} from '../../../../components/abstract/translation-container.component';
import {OfferRecommendationConfig} from '../../../../../core/models/offer/offer-recommendation-config';
import {OfferRecommendationsService} from '../../../../../core/services/impl/offer-recommendations.service';
import {isNestBank} from '../../../../../core/utils/utils';

@Component({
  selector: 'app-missing-recommendation-tile',
  templateUrl: './missing-recommendation-tile.component.html',
  styleUrls: []
})
export class MissingRecommendationTileComponent extends TranslationContainerComponent implements OnInit {

  @Input() recommendation: OfferRecommendation;

  imageSrc: string;

  get config(): OfferRecommendationConfig {
    return this.offerRecommendationsService.getConfig(this.recommendation.recommendationType);
  }

  get cssClassSuffix(): string {
    return this.offerRecommendationsService.getRoleConfig(this.recommendation.recommendationType).cssClassSuffix;
  }

  constructor(private offerRecommendationsService: OfferRecommendationsService) {
    super('OFFER_SECTION.MISSING_RECOMMENDATION_TILE');
  }

  ngOnInit() {
    this.initImageSrc();
  }

  contactWithUs(): void {
    window.open('https://kioskpolis.pl/zamow-rozmowe/', '_blank');
  }

  private initImageSrc(): void {
    this.imageSrc = isNestBank() ? './assets/images/missing-offer-recommendation-nest-bank.svg' : './assets/images/missing-offer-recommendation.svg';
  }

}
